import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncPasswordRecoveryNewPassword = loadable(
  () => import('./PasswordRecoveryNewPassword'),
  {
    fallback: <Loader />,
  },
);
